const ru = {
  brand: {
    name: 'POWER',
    desc: 'АвтоСервис',
  },

  nav: {
    services: 'Услуги',
    prices: 'Цены',
    about: 'О нас',
    contacts: 'Контакты',
    contactUs: 'Связаться',
    workHours: 'Ежедневно 10:00–19:00',
  },

  hero: {
    badge: '⭐ Более 10 лет на рынке автоуслуг',
    title1: 'Профессиональный',
    titleAccent: ' автосервис',
    title2: 'в Улан-Баторе',
    text: 'Выполняем все виды ремонта и обслуживания автомобилей любых марок. Гарантия на работы — 1 год. Современное оборудование и опытные мастера.',
    stat1num: '12 000+',
    stat1label: 'довольных клиентов',
    stat2num: '10+',
    stat2label: 'лет опыта',
    stat3num: '1',
    stat3label: 'год гарантии',
    btnBooking: 'Записаться на ремонт',
    btnPrices: 'Узнать цены',
    card1title: 'Бесплатная диагностика',
    card1text: 'при ремонте от 5 000 ₽',
    card2title: 'Оригинальные запчасти',
    card2text: 'поставка за 1-2 дня',
    card3title: 'Срочный ремонт',
    card3text: 'день в день',
  },

  services: {
    title: 'Наши услуги',
    subtitle: 'Полный спектр услуг по ремонту и обслуживанию автомобилей всех марок',
    more: 'Подробнее →',
  },

  advantages: {
    title: 'Почему выбирают нас',
    subtitle: '«Мы предоставляем надежные, качественные и гарантированные услуги по обслуживанию вашего автомобиля — быстро, эффективно и с комфортом, обеспечивая при этом его безопасность».',
    items: [
      { icon: '🕐', title: 'Быстрый ремонт', text: 'Большинство работ выполняем в день обращения. Сложный ремонт — от 1 до 3 дней.' },
      { icon: '💎', title: 'Гарантия 1 год', text: 'Предоставляем гарантию на все виды выполненных работ.' },
      { icon: '📋', title: 'Прозрачные цены', text: 'Согласовываем стоимость до начала работ. Никаких скрытых доплат.' },
      { icon: '🚗', title: 'Все марки авто', text: 'Работаем с автомобилями всех марок: от бюджетных до премиальных.' },
      { icon: '🔧', title: 'Проф. оборудование', text: 'Современные стенды, сканеры и инструмент от ведущих производителей.' },
      { icon: '📱', title: 'Онлайн-запись', text: 'Запишитесь на удобное время через сайт или мессенджер за 1 минуту.' },
    ],
  },

  about: {
    title: 'О нашем автосервисе',
    text1: 'Power Auto Service — это современный автосервис полного цикла в Улан-Баторе. Мы работаем с 2016 года и за это время обслужили более 12 000 автомобилей.',
    text2: 'Наши специалисты проходят регулярное обучение и постоянно повышают квалификацию. Мы используем только профессиональное оборудование и оригинальные запчасти.',
    features: [
      { icon: '🏆', title: 'Сертифицированный центр', text: 'Лицензии и сертификаты на все виды работ' },
      { icon: '👥', title: 'Опытная команда', text: 'Средний стаж мастеров — более 8 лет' },
      { icon: '🔒', title: 'Гарантия качества', text: '1 год гарантии на работы' },
      { icon: '💰', title: 'Честные цены', text: 'Без скрытых платежей и навязанных услуг' },
    ],
    yearsLabel: 'лет работы',
    imageTitle: 'Наш автосервис',
  },

  prices: {
    title: 'Цены на услуги',
    subtitle: 'Актуальные цены на основные виды работ. Точную стоимость уточняйте после диагностики.',
    headerWork: 'Вид работы',
    headerPrice: 'Стоимость',
    note: 'Указаны цены за работу без учёта стоимости запчастей. Точную стоимость мастер рассчитает после диагностики вашего автомобиля.',
    rateDisclaimer:
      'Цены в рублях пересчитаны по официальному курсу Банка Монголии и могут меняться при обновлении курса. Базовая валюта — тугрик (₮).',
  },

  booking: {
    title: 'Запишитесь на ремонт',
    text: 'Оставьте заявку, и мы перезвоним вам в короткие сроки для уточнения деталей и подбора удобного времени.',
    benefit1: 'Бесплатная диагностика при ремонте',
    benefit2: 'Перезвоним в короткие сроки',
    benefit3: 'Фиксированная цена после осмотра',
    benefit4: 'Гарантия на все работы',
    orCall: 'Или позвоните нам:',
    nameLabel: 'Ваше имя',
    namePlaceholder: 'Иван Иванов',
    phoneLabel: 'Телефон',
    carLabel: 'Марка и модель авто',
    carPlaceholder: 'TOYOTA Land Cruiser 200 2020',
    serviceLabel: 'Услуга',
    serviceDefault: 'Выберите услугу',
    dateLabel: 'Желаемая дата',
    commentLabel: 'Комментарий',
    commentPlaceholder: 'Опишите проблему или пожелания...',
    submit: '📋 Отправить заявку',
    sending: 'Отправка...',
    privacy: 'Нажимая кнопку, вы соглашаетесь с политикой обработки персональных данных',
  },

  carousel: {
    title: 'Частые гости нашего сервиса',
    subtitle: 'Автомобили, которые регулярно обслуживаются у нас',
    imageAlt: 'Автомобиль',
    items: [
      'TOYOTA Land Cruiser Prado 120',
      'TOYOTA Land Cruiser Prado 150',
      'TOYOTA Hilux 185',
      'TOYOTA Hilux 215',
      'LEXUS RX 450',
      'TOYOTA Land Cruiser 200',
    ],
  },

  gallery: {
    title: 'Наш автосервис',
    subtitle: 'Современное оборудование и комфортные условия',
    items: [
      { emoji: '🔧', title: 'Ремонтная зона' },
      { emoji: '🖥️', title: 'Диагностика' },
      { emoji: '🏗️', title: 'Подъёмники' },
      { emoji: '🛞', title: 'Шиномонтаж' },
      { emoji: '⚙️', title: 'Зона Ожидания' },
      { emoji: '🧰', title: 'Инструменты' },
    ],
  },

  contacts: {
    title: 'Контакты',
    subtitle: 'Приезжайте к нам или свяжитесь удобным способом',
    address: 'Адрес',
    addressValue: 'г. Улан-Батор, СБД, 12 комитет, 32 район',
    phone: 'Телефон',
    phone2: 'Телефон 2',
    email: 'Email',
    schedule: 'Режим работы',
    weekdays: 'Ежедневно, без выходных: 10:00 — 19:00',
    nightSurcharge:
      'Вызов мастера в ночную смену — дополнительно 200 000 ₮ к стоимости услуги.',
    map: 'Карта',
    mapHint: 'Яндекс карта или Google Maps',
  },

  contact: {
    title: 'Связаться с нами',
    subtitle: 'Выберите удобный способ связи',
    callTitle: 'Позвонить',
    callDesc: 'Свяжитесь с нами прямо сейчас',
    formTitle: 'Оставить контакты',
    formDesc: 'Мы перезвоним вам в ближайшее время',
    formTag: 'Ответим в короткие сроки',
    orWrite: 'Или напишите в мессенджер:',
    back: 'Назад',
    leaveContacts: 'Оставьте ваши данные',
    leaveContactsDesc: 'Наш менеджер получит уведомление и свяжется с вами',
    nameLabel: 'Ваше имя',
    namePlaceholder: 'Иван Иванов',
    phoneLabel: 'Телефон',
    preferredContact: 'Как с вами связаться?',
    byPhone: 'Звонок',
    tgUsernameLabel: 'Ваш Telegram username',
    tgUsernamePlaceholder: '@username',
    tgUsernameHint: 'Ваш юзернейм в Telegram, чтобы мы могли вам написать',
    messageLabel: 'Сообщение',
    messagePlaceholder: 'Опишите вопрос или проблему...',
    sendButton: '📨 Отправить заявку',
    sending: 'Отправка...',
    privacy: 'Нажимая кнопку, вы соглашаетесь с обработкой персональных данных',
    errorRequired: 'Заполните обязательные поля',
    errorPhone: 'Введите номер телефона полностью',
    errorTgUsername: 'Укажите ваш Telegram username',
    errorTgUsernameShort: `Telegram username слишком короткий (минимум 3 символа)`,
    errorSend: 'Ошибка отправки. Попробуйте позвонить нам.',
    successTitle: 'Заявка отправлена!',
    successDesc: 'Наш менеджер свяжется с вами в ближайшее время.',
    close: 'Закрыть',
  },

  footer: {
    about: 'Профессиональный автосервис полного цикла в Улан-Баторе. Ремонт и обслуживание автомобилей всех марок с гарантией.',
    servicesTitle: 'Услуги',
    svcDiag: 'Вибродиагностика',
    svcComputer: 'Компьютерная диагностика',
    svcBalance: 'Балансировка колёс',
    svcAlignment: 'Развал-схождение',
    svcOil: 'Замена моторного масла',
    infoTitle: 'Информация',
    aboutCompany: 'О компании',
    privacyPolicy: 'Политика конфиденциальности',
    contactsTitle: 'Контакты',
    copyright: 'Все права защищены.',
    disclaimer: 'Сайт носит информационный характер и не является публичной офертой.',
  },

  videos: {
    title: 'Видео из нашего сервиса',
    subtitle: 'Посмотрите, как мы работаем',
    items: [
      { id: 'dc7pvBSpP4A', title: 'Вибродиагностика' },
      { id: 'SxqCOpLyw2o', title: 'Замена масленного фильтра' },
      { id: 'ALmPLMTOWrM', title: 'Диагностика автомобильного компьютера' },
      { id: 'qsqPJbfwH9w', title: 'Услуги по балансировке колес работы' },
      { id: 'nNwqK3CpuM0', title: 'Регулировка угла развала-схождения колес' },
    ],
  },

  parts: {
    toggleBtn: 'Цены на запчасти по моделям авто',
    oilsLabel: 'Масла и фильтры',
    partsLabel: 'Запчасти ходовой',
    headerName: 'Наименование',
    headerQty: 'Кол-во',
    headerBrand: 'Бренд',
    headerPrice: 'Цена за шт.',
    disclaimer: 'Цены ориентировочные и действительны на 2026 год. Итоговая стоимость зависит от результатов диагностики. При покупке запчастей у нас — установка большинства деталей бесплатно.',
    rateDisclaimer:
      'Цены в рублях пересчитаны по официальному курсу Банка Монголии и могут меняться при обновлении курса. Базовая валюта — тугрик (₮).',
  },

  servicePage: {
    back: '← Вернуться на главную',
    pricesTitle: 'Стоимость работ',
  },

};

export default ru;
